import {BaseModel} from './BaseModel';
import {Request} from "./Request";
import {Utils} from "../common/Utils";
import {BaseClass} from "../base/BaseClass";
import {BaseList} from "./BaseList";
import {Model} from "./Model";

/**
 * The DataList class represents a list of data entries from the query controller of the ARGO Rest API by using the {@link Request} class.
 * Every data entry of the result list will be wrapped into a {@link Model} class.
 *
 * Notice: This implementation handles only the ARGO collection "dataEntries".
 */
export class DataList extends BaseList {

  constructor(type, options = {}) {

       // type can be the first argument or defined in options (for compatibility)
    if (!Utils.isString(type)) {
      options = type;
      type = options.type || null;
    }
    // keep type information in config key from {@link BaseClass}
    options.type = type;

    // defaults for working with data entries
    options.collection = 'dataEntries';
    options.model = options.model || Model;


    /*if (!(options.model instanceof Model)) {
      throw "DataList expects a model that extends Model."
    }*/

    super(options);

    /**
     * Name of ARGO's content type
     * @type {String}
     */
    this.type = type;
    /**
     * Name of the primary key from the content type, default: id
     * @type {String}
     */
    this.pk = options.pk || 'id';
    /**
     * List indexed by primary key
     * @type {{}}
     * @private
     */
    this._listByPk = {};
  }

  /**
   * Reset the list instance, that means all models will be removed.
   * @param options
   * @param {boolean} [options.silent] - prevent event emit
   */
  onBeforeReset(options = {}) {
    this._listByPk = {};
  }

  /**
   * Create a model instance from the given data object.
   * @param {Object} data
   * @return {Model}
   * @private
   */
  _createListItem(data) {
    let model = super._createListItem(data);
    this._listByPk[model.getPk()] = model;
    return model;
  }

  /**
   * Returns the model with the given primary key or null if not found.
   * @param {*} pk - primary key from model
   * @return {BaseModel|null}
   */
  findByPk(pk) {
    if (this._listByPk.hasOwnProperty(pk)) {
      return this._listByPk[pk];
    }
    return null;
  }

  /**
   * To be called before fetching data. Set the type parameter in the query.
   * @param options
   */
  onBeforeFetch(options) {
    this.query.type = this.type;
  }

  /**
   * Add the given model to the primary key map
   * @param model
   * @param options
   * @private
   */
  _add(model, options = {}) {
    this._listByPk[model.getPk()] = model;
  }

  /**
   * Remove the given model from the list. The model instance must
   * exists in the list.
   * @param {BaseModel} model - model instance to be removed
   * @param {Object} options
   * @return {BaseList}
   */
  remove(model, options = {}) {
    if (model instanceof BaseModel) {

      let index = this._removeInternal(model);
      if (index === -1) {
        return false;
      }

      if (options.silent !== true) {
        this.emit('remove', this, model, index);
      }
    }
    return this;
  }

  /**
   * Remove given model from pk map.
   * @param {Model} model
   * @return {number}
   * @private
   */
  _remove(model) {
    delete this._listByPk[model.getPk()];
  }

}